import { useMediaQuery, useTheme } from '@mui/material';
import { AvatarPlaceHolder } from '../../placeholders/avatar.placeholder';
import { usePlaceholderStyles } from '../../placeholders/placeholders.styles';
import { TextPlaceholder } from '../../placeholders/text.placeholder';
import { useTimelineRowStyles } from './timeline-row.styles';

export function TimelineRowPlaceholder() {
  const classes = useTimelineRowStyles({});
  const placeholderClasses = usePlaceholderStyles({});
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        <div className={classes.icon}>
          <AvatarPlaceHolder />
        </div>
        <div className={classes.content}>
          <TextPlaceholder fontSize={15} width={'150px'} />
          <TextPlaceholder fontSize={14} width={isXS ? '100%' : '70%'} />
        </div>
      </div>
      <div className={[classes.divider, classes.dividerStyle, placeholderClasses.pulse].join(' ')}></div>
    </div>
  );
}
